import { defineStore } from 'pinia';
import {EditableUserData, User} from "@/scripts/types/users";
import {getUser, updateUser} from "@/scripts/api/users";
import { useToast } from "vue-toastification";

const useUser = defineStore('user', {
    state: (): User => {
        return {
            email: "",
            id: 0,
            timezoneId: 0
        }
    },
    actions: {
        async getData() {
            try {
                const user = await getUser()

                const {
                    id,
                    email,
                    timezoneId
                } = user;

                this.id = id
                this.email = email
                this.timezoneId = timezoneId
            } catch (error: any) {}
        },

        async setData(updates: EditableUserData) {
            await updateUser(updates)
            const toasts = useToast();
            toasts.success('Данные сохранены!');

            await this.getData();
        },
    },
})

export default useUser;
